import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { path: "/relations", label: "人物关系" },
  { path: "/cp-lines", label: "CP 线" },
  { path: "/daily", label: "师门日常" },
  { path: "/about", label: "关于我们" },
];

const CATEGORY_LINKS = [
  { path: "/relations", label: "师兄关系亲疏" },
  { path: "/relations", label: "师姐互动名场面" },
  { path: "/relations", label: "同门情谊暗线" },
  { path: "/cp-lines", label: "CP 线发展脉络" },
];

export default function Footer() {
  return (
    <footer className="bg-background-800 text-foreground-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-2xl text-background-50">
                师
              </span>
              <span className="font-[Ma_Shan_Zheng] text-2xl text-accent-300">师兄啊师兄</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-200/80">
              面向《师兄啊师兄》读者的追更补课站。师兄关系亲疏、师姐互动名场面、同门情谊暗线与 CP
              线发展脉络一页理清，师门日常细节同步更新，助你追更前先补好人物关系课。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-accent-200">快速导航</h4>
            <ul className="mt-4 space-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.path}
                    className="whitespace-nowrap text-sm text-foreground-200/80 transition-colors hover:text-accent-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-accent-200">内容栏目</h4>
            <ul className="mt-4 space-y-3">
              {CATEGORY_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.path}
                    className="whitespace-nowrap text-sm text-foreground-200/80 transition-colors hover:text-accent-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-background-700/70 pt-6">
          <p className="text-center text-xs leading-6 text-foreground-300/70">
            本站为粉丝自发的内容整理与盘点站，非官方站点。所有人物关系、CP 线与师门日常内容均为按原作品整理的追更笔记，仅供参考，具体设定请以作品原作为准。
          </p>
          <p className="mt-3 text-center text-xs text-foreground-300/70">
            © {new Date().getFullYear()} 师兄啊师兄人物关系百科 · 追更前先补课
          </p>
        </div>
      </div>
    </footer>
  );
}